export default __webpack_public_path__ + "static/media/portfolio-196.1b336105.jpg";